import type { DefinedError } from 'ajv';
import type { FieldError } from 'react-hook-form';
import { appendErrors } from 'react-hook-form';

/**
 * Transforming Ajv errors to react-hook-form.
 * Logic extensivly taken from react-hook-form own Ajv resolver (this logic is not exposed from the package).
 * @param ajvErrors Error reported by Ajv
 * @param validateAllFieldCriteria Validate all field criteria
 * @returns A record with errors supported by react-hook-form
 */
export const parseErrorSchema = (ajvErrors: DefinedError[], validateAllFieldCriteria: boolean) => {
  // Ajv will return empty instancePath when require error
  ajvErrors.forEach((error) => {
    if (error.keyword === 'required') {
      error.instancePath += '/' + error.params.missingProperty;
      // Avoids default ajv error message for required integer or number fields
      error.message = 'form-lottery-name-error-message-min-length';
    }
  });

  return ajvErrors.reduce<Record<string, FieldError>>((previous, error) => {
    // `/deepObject/data` -> `deepObject.data`
    const path = error.instancePath.substring(1).replace(/\//g, '.');

    if (!previous[path]) {
      previous[path] = {
        message: error.message,
        type: error.keyword,
      };
    }

    if (validateAllFieldCriteria) {
      const types = previous[path].types;
      const messages = types?.[error.keyword];

      previous[path] = appendErrors(
        path,
        validateAllFieldCriteria,
        previous,
        error.keyword,
        messages
          ? ([] as string[]).concat(messages as string[], error.message || '')
          : error.message
      ) as FieldError;
    }

    return previous;
  }, {});
};
